export default function Footer() {
  return (
    <footer className="w-full section">
      <svg className="w-14 h-[24px] mx-auto">
        <use xlinkHref="#brit-logo" />
      </svg>
    </footer>
  );
}
